__turbopack_context__.v({
  "disabled": "BmaX3q_disabled",
  "icon": "BmaX3q_icon",
  "loading": "BmaX3q_loading",
  "standalone": "BmaX3q_standalone",
  "standaloneDisabled": "BmaX3q_standaloneDisabled",
  "standaloneLarge": "BmaX3q_standaloneLarge",
  "standaloneSmall": "BmaX3q_standaloneSmall",
});
